import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "../../styles/Modal.css";

const CustomModal = ({
  handleClose,
  headingTitle,
  loading,
  show,
  children,
  handleSubmit,
  submitTitle = "Submit",
  isIcon = false,
  icon,
}) => {
  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        {headingTitle && (
          <Modal.Header closeButton>
            <Modal.Title>{headingTitle}</Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            disabled={loading ? true : false}
            type="button"
            onClick={handleSubmit}
            className="concern-submit-btn"
            variant="primary"
            style={{
              backgroundColor: "#F5C000",
              borderColor: "#F5C000",
              color: "#000",
              fontWeight: "#800",
            }}
          >
            {`${loading ? "Processing..." : submitTitle}`}
            {isIcon && (
              <FontAwesomeIcon
                style={{
                  marginLeft: "1rem",
                }}
                icon={icon}
              />
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomModal;
